module.exports = __webpack_public_path__ + "img/avatar.11fcabff.jpg";